export default function (element) {
    try {
        let bounding = element.getBoundingClientRect();
        let out = {
            top: false,
            left: bounding.left < 0,
            bottom: bounding.bottom > (window.innerHeight || document.documentElement.clientHeight),
            right: bounding.right > (window.innerWidth || document.documentElement.clientWidth),
        };

        out.any = out.top || out.left || out.bottom || out.right;
        out.all = out.top && out.left && out.bottom && out.right;

        return out;
    } catch (error) {
        // :shrug:
        return {
            top: false,
            left: false,
            bottom: false,
            right: false,
            any: false,
            all: false,
        };
    }
};
